module.exports = __webpack_public_path__ + "static/img/wheelBlack.6753484.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/car/wheelBlack.png
// module id = qNDU
// module chunks = 1